module.exports = __webpack_public_path__ + "01_mid_brown.5e177503.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/01_mid_brown.png
// module id = LA2P
// module chunks = 0